module.exports = __webpack_public_path__ + "static/Android_iOS-19a733b1cd212bf257c0388291fbf736.jpg";